var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 9.49834V6.52569C14.5 5.02974 13.5492 3.69917 12.134 3.21449L11.744 3.08092C11.366 2.95147 10.952 2.97816 10.5938 3.15506C10.2356 3.33195 9.96276 3.64445 9.83578 4.02325L8 9.49956H4.4375C3.64359 9.49956 3 10.1431 3 10.9371V19.5621C3 20.356 3.64359 20.9996 4.4375 20.9996H17.6861C19.0053 20.9996 20.1553 20.1017 20.4752 18.8218L21.9127 13.0718C22.1275 12.213 21.9345 11.3031 21.3897 10.6052C20.8448 9.90744 20.0089 9.49956 19.1236 9.49956H14.5",
    fill: "#DDDEFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.49834V6.52569C14.5 5.02974 13.5492 3.69917 12.134 3.21449L11.744 3.08092C11.366 2.95147 10.952 2.97816 10.5938 3.15506C10.2356 3.33195 9.96276 3.64445 9.83578 4.02325L8 9.49956H4.4375C3.64359 9.49956 3 10.1431 3 10.9371V19.5621C3 20.356 3.64359 20.9996 4.4375 20.9996H17.6861C19.0053 20.9996 20.1553 20.1017 20.4752 18.8218L21.9127 13.0718C22.1275 12.213 21.9345 11.3031 21.3897 10.6052C20.8448 9.90744 20.0089 9.49956 19.1236 9.49956H14.5",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 21V9.5",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.06e6367d.svg";
export { ForwardRef as ReactComponent };